import { render } from "./NITMicBrothers.vue?vue&type=template&id=34c7b617"
import script from "./NITMicBrothers.vue?vue&type=script&lang=js"
export * from "./NITMicBrothers.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__